module.exports = function() {
  return new Worker("/" + "sass-transpiler.7a506e59.worker.js");
};